module.exports = __webpack_public_path__ + "static/media/menu.f8f519f0.svg";